import MuiChip, { ChipProps } from "@mui/material/Chip";
import { getStyleProps } from "modules/themes/styleUtils";
import React from "react";
export { ChipProps };
export const Chip = React.forwardRef((props: ChipProps, ref) => {
  return <MuiChip {...props} {...getStyleProps(props)} ref={ref} />;
});

Chip.displayName = "Chip";
